import { render, staticRenderFns } from "./FinalCheckAndCampaignRelease.vue?vue&type=template&id=50fb54fc&scoped=true&"
import script from "./FinalCheckAndCampaignRelease.vue?vue&type=script&lang=js&"
export * from "./FinalCheckAndCampaignRelease.vue?vue&type=script&lang=js&"
import style0 from "./FinalCheckAndCampaignRelease.vue?vue&type=style&index=0&id=50fb54fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fb54fc",
  null
  
)

export default component.exports